export const setStep = ([stop, fieldName], state, utils) => {
    utils.changeValue(state, `${fieldName}Step`, () => stop.step);
};
export const setStop = ([stop, fieldName], state, utils) => {
    utils.changeValue(state, `${fieldName}`, () => stop);
};

export const setValue =([field, value], state, { changeValue }) => {
    changeValue(state, field, () => value)
}